<template>
  <b-row class="px-4">
    <b-col sm="12" class="result-summary rounded">
      <!-- {{params}} -->
      <div class="d-flex justify-content-between">
        <template v-if="category">
          <div class="mx-2">
            <span class="tag-details" v-translate>Room type</span>: <span class="name-details">{{category.name}}</span>
          </div>
          <div class="mx-2">
            <span class="tag-details" v-translate>Meal type</span>: <span class="name-details">{{meal.label}}</span>
          </div>
        </template>
        <div class="mx-2">
          <span class="tag-details"><translate>Departure date</translate>: </span> <span class="name-details">{{ model.params.checkIn }}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>Return date</translate>: </span> <span class="name-details">{{model.params.checkOut}}</span>
        </div>
        <div class="mx-2">
          <span class="tag-details"><translate>No. nights</translate>: </span> <span class="name-details">{{duration}} <translate>nights</translate></span>
        </div>
        <div v-for="(room, index) in params.rooms" :key="index" class="mx-2">
          <span class="tag-details"><translate>Room</translate> {{index + 1 }} - </span>
          <span>{{room.adults}} </span><span class="name-details"> <translate>adults</translate> </span>
          <span v-if="room.ages && room.ages.length" class="name-details">, {{ room.ages.length }} <translate>childern</translate></span>
        </div>
      </div>
      <hr class="my-1"/>
      <div>
       <small class="float-right">
          <b v-translate>generated by</b> -
          <span class="name-details"> {{userData.fname}} {{userData.lname}}</span> /
          <span class="name-details"> {{dateNow}}</span>
       </small>
     </div>
    </b-col>
  </b-row>
</template>

<script>
import moment from 'moment'
import auth from 'b2b-common/mixins/auth'
import model from '../services/model'

export default {
  props: ['params', 'result', 'category', 'meal'],
  mixins: [auth],
  data () {
    return {
      model
    }
  },
  computed: {
    duration () {
      return moment(model.params.checkOut, 'DD-MM-YYYY').startOf('day').diff(moment(model.params.checkIn, 'DD-MM-YYYY').startOf('day'), 'days')
    },
    dateNow () {
      const date = moment(this.dateToday)
      return date.format('DD-MM-YYYY - [ora ]LT')
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
